import React from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { MeetingRoom as ZoomIcon } from '@mui/icons-material';
import { Video } from 'lucide-mui';
import { RootState } from '../../../reducers';

const ZoomIntegration = () => {
  const theme = useTheme();
  const { isConnected, email } = useSelector(
    (state: RootState) => state.settings.user.integrations.zoom
  );
  // const dispatch = useDispatch();

  const handleZoomIntegration = () => {
    window.location.href =
      'https://zoom.us/oauth/authorize?response_type=code&client_id=XnZQ5N7ISXqwAVY8XV2ang&redirect_uri=https://dev.screenapp.io/app/%23/dashboard';
  };

  // const handleDisconnect = () => {
  //   // Disconnect logic
  // };

  return (
    <Card>
      <CardContent>
        <Stack spacing={2} alignItems="center" sx={{ py: 4 }}>
          <Video
            sx={{
              color: theme.palette.primary.main,
              strokeWidth: 1.5,
              width: 48,
              height: 48,
            }}
          />
          <Typography variant="h6" color="inherit">
            Zoom Integration
          </Typography>
          {isConnected ? (
            <>
              <Typography variant="body2" color="text.secondary">
                You are connected with this email:{' '}
                <strong>{email || 'Unknown'}</strong>
              </Typography>
              <Typography variant="body2" color="text.secondary" align="center">
                To disconnect, go to the <strong>Zoom Marketplace</strong> and
                remove the <strong>ScreenApp</strong> integration.
              </Typography>
              {/* <Button
                onClick={handleDisconnect}
                variant="contained"
                startIcon={<ZoomIcon />}
                data-testid="disconnect-zoom-button"
              >
                Disconnect
              </Button> */}
            </>
          ) : (
            <>
              <Typography variant="body2" color="text.secondary" align="center">
                Connect your Zoom account to automatically import your
                recordings.
                <br />
                Follow the instructions provided on the next page after clicking
                Connect.
              </Typography>
              <Button
                onClick={handleZoomIntegration}
                variant="contained"
                startIcon={<ZoomIcon />}
                data-testid="connect-zoom-button"
              >
                Connect with Zoom
              </Button>
            </>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ZoomIntegration;
